<template>
	<!-- 底部手机端 --- zhangqin 2024.3.14 -->
	<div class="app-footer">
		<div class="footer-cont">
			<div class="p16">
				<div class="ft-gzwm">{{ $t('m.关注我们') }}</div>
				<img class="ft-ewm" src="@/assets/imgs/footerEWM.png" />
				<div class="ft-lxfs">{{ $t('m.快捷导航') }}</div>
				<div class="ft-zhichi">
					{{ $t('m.我们支持可为您提供24小时全天候的帮助') }}
				</div>
				<div class="ft-phone">
					<div class="ftp-item flex">
						<img src="@/assets/imgs/footerPhone.png" />
						<span>{{ aboutusObj.phone }}</span>
					</div>
					<div class="ftp-item flex">
						<img src="@/assets/imgs/footerEmail.png" />
						<span>{{ aboutusObj.email }}</span>
					</div>
					<div class="ftp-item flex">
						<img src="@/assets/imgs/footerInter.png" />
						<span>{{ aboutusObj.web }}</span>
					</div>
					<div class="ftp-item flex">
						<img src="@/assets/imgs/footerMap.png" />
						<span>{{ aboutusObj.address }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bom">
			维多科流体技术（重庆）有限公司
			<a href="https://beian.miit.gov.cn/" target="_blank"
				>渝ICP备2024027752号-1</a
			>
		</div>
	</div>
</template>

<script>
import { getaboutus } from '@/api/home'
export default {
	name: 'appFooterPhone',
	data() {
		return {
			navList: [
				{ name: this.$t('m.首页'), value: 1, path: '/' },
				{ name: this.$t('m.产品'), value: 2, path: '/product' },
				{ name: this.$t('m.解决方案'), value: 3, path: '/battery' },
				{ name: this.$t('m.支持'), value: 4, path: '/information' },
				{ name: this.$t('m.关于'), value: 5, path: '/about' },
			],
			aboutusObj: {},
		}
	},
	created() {
		this.getaboutusData()
	},
	methods: {
		// 获取关于我们内容
		getaboutusData() {
			let params = {
				lng: window.sessionStorage.getItem('language'),
			}
			getaboutus(params).then((res) => {
				this.aboutusObj = res
			})
		},
		// 跳转页面
		toPage(item) {
			this.$store.commit('navbgshow', item.value)
			if (this.$route.path != item.path) {
				this.$router.push(item.path)
			}
			window.scrollTo({ top: 0, behavior: 'smooth' })
		},
	},
}
</script>
<style scoped lang="scss">
.app-footer {
	width: 100%;
	.footer-cont {
		width: 100%;
		background: url('@/assets/imgs/footerBg.png') no-repeat;
		background-size: cover;
		padding-top: 20px;
		padding-bottom: 2px;
		.ft-gzwm {
			font-size: 10px;
			color: #474747;
			font-weight: bold;
		}
		.ft-ewm {
			width: 93px;
			height: 93px;
			margin-top: 8px;
		}
		.ft-kjdh {
			font-size: 20px;
			color: #474747;
			font-weight: bold;
			margin-top: 40px;
		}
		.ft-tabs {
			margin-top: 16px;
			.ftt-item {
				font-size: 16px;
				color: #474747;
				font-weight: 500;
				cursor: pointer;
				.ftti-heng {
					width: 6px;
					height: 1px;
					background-color: #474747;
					display: inline-block;
					margin: 0 20px;
				}
			}
		}
		.ft-lxfs {
			font-size: 14px;
			color: #474747;
			font-weight: bold;
			margin-top: 25px;
		}
		.ft-zhichi {
			font-size: 10px;
			color: #474747;
			font-weight: 500;
			margin-top: 10px;
		}
		.ft-phone {
			margin-top: 28px;
			.ftp-item {
				font-size: 12px;
				font-weight: 500;
				color: #474747;
				margin-bottom: 10px;
				img {
					width: 10px;
					height: 10px;
					margin-right: 6px;
				}
			}
		}
	}
	.footer-bom {
		padding: 10px 0;
		text-align: center;
		font-size: 9px;
		color: #474747;
		a {
			font-size: 9px;
			color: #474747;
		}
	}
}
</style>
